import { AxiosInstance } from 'axios';
import { plainToInstance } from 'class-transformer';
import { BusinessDTO } from '../commons/dtos/business.dto';
import { IBusiness } from '../commons/interfaces/business.interface';
import { IChatbotAPIResponsePagination } from '../commons/interfaces/chatbotAPI.interface';
import Axios from './axios.service';

export default class BusinessAPI {
  private request: AxiosInstance;

  constructor() {
    this.request = Axios.getInstance();
  }

  listBusinesses = async (page: number) => {
    const response = await this.request.get<IChatbotAPIResponsePagination<IBusiness[]>>(
      '/businesses',
      { params: { pageSize: 10, page } }
    );

    const data = plainToInstance(BusinessDTO, response.data.data);

    return { data, pagination: response.data.pagination };
  };
}
